import { ChangeDetectionStrategy, Component, computed, EventEmitter, inject, Input, Output } from '@angular/core';
import { AppUser } from 'src/app/shared/models/app-user';
import { AppSettingsDto, FilterDto, VisualFieldDto } from '../../../services/api.services';
import { InsightsLibraryActions, InsightsLibrarySelectors, InsightsLibraryVisual } from '../../state/insights-library';
import { FilterUtils } from 'src/app/pbir/utils/FilterUtils';
import { InsightsLibraryComponent } from '../insights-library/insights-library.component';
import { DataFormatter } from 'src/app/pbir/formatting/DataFormatter';
import { VisualFieldTargetResolver } from 'src/app/pbir/visuals/VisualFieldTargetResolver';
import { AppCurrencyService } from 'src/app/app/AppCurrencyService';

@Component({
  selector: 'app-insights-library__insights',
  templateUrl: './insights.component.html',
  styleUrls: ['./insights.component.scss'],
  standalone: false
})
export class InsightsLibraryInsightsComponent {
  readonly insightsLibrary = inject(InsightsLibraryComponent);
  readonly currencyService = inject(AppCurrencyService);

  @Input() user: AppUser;
  @Input() busy = false;

  @Input() appSettings: AppSettingsDto;

  @Output() categorySelected = new EventEmitter<any>();
  @Output() itemSelected = new EventEmitter<any>();

  @Output('favourite') _favourite = new EventEmitter<InsightsLibraryVisual>();
  @Output('addToHome') _addToHome = new EventEmitter<InsightsLibraryVisual>();
  @Output('view') _view = new EventEmitter<InsightsLibraryVisual>();
  @Output('copyVisual') _copy = new EventEmitter<InsightsLibraryVisual>();

  itemSelectorActions = InsightsLibraryActions.visualItemSelector;
  itemSelectorSelectors = InsightsLibrarySelectors.visualItemSelector;

  suggestAnInsightMailTo = 'mailto:suggestaninsight@trgscreen.com?subject=Suggest%20an%20Insight!&body=I%20would%20like%20to%20suggest%20the%20following%20Insight%20to%20be%20added.%20(Please%20provide%20the%20following%20info)%3A%0D%0A%0D%0ABrief%20description%20of%20the%20Insight%3A%0D%0A%0D%0AWhy%20is%20this%20valuable%2C%20what%20call%20to%20action%20might%20this%20provide%20to%20me%3F%3A%0D%0A%0D%0AA%20suggestion%20of%20which%20data%20to%20use%2C%20how%20the%20data%20can%20be%20manipulated%2C%20to%20provide%20this%20Insight%3A%0D%0A%0D%0AWhat%20type%20of%20visual%20would%20you%20suggest%20be%20used%3F%3A';

  formatFieldTitle(item: InsightsLibraryVisual, index: number) {
    let m = this.insightsLibrary.dataModel();
    if (!m)
      return '';

    let field = item.fields[index] as any;
    return field.__fieldTitle ??= VisualFieldTargetResolver.create({
      currencies: this.currencyService.currencies,
      dataModel: m,
      customFields: [],
      schema: item.visual.schema
    }).find(field.target)?.shortTitle;
  }

  formatFilter(item: InsightsLibraryVisual, index: number) {
    let m = this.insightsLibrary.dataModel();
    if (!m)
      return '';

    let filter = item.filters[index] as any;

    return filter.__filterDesc ??= (() => {
      let currencies = this.currencyService.currencies();

      let fieldResolver = VisualFieldTargetResolver.create({
        currencies,
        dataModel: m,
        customFields: [],
        schema: item.visual.schema
      });

      let dataFormatter = DataFormatter.createDefault({ currencies });
      return new FilterUtils.Formatter(fieldResolver, dataFormatter).formatDescription(filter, {
        capitalizeFirstWord: true,
        noHtml: false
      });
    })();
  }


  favourite(item: InsightsLibraryVisual) {
    this._favourite.emit(item);
  }

  addToHome(item: InsightsLibraryVisual) {
     this._addToHome.emit(item);
  }

  view(item: InsightsLibraryVisual) {
    this._view.emit(item);
  }

  copy(item: InsightsLibraryVisual) {
    this._copy.emit(item);
  }
}
